'use strict'
// Template version: 1.3.1
// see http://vuejs-templates.github.io/webpack for documentation.

var path = require('path')
var baseUrl = require('./baseUrl') // 杨志的ip
module.exports = {
  dev: {
    baseURL: baseUrl,
    httpSetting: { // http请求设置
      timeout: 60000, // 超时时间
      responseType: 'json',
      baseURL: baseUrl // 结果返回类型，默认全部为json，其它类型的单独处理
    },
    // Paths
    assetsSubDirectory: 'static',
    assetsPublicPath: '/',
    proxyTable: {
      '/test': {
        target: 'http://localhost:11001/',
        changeOrigin: true,
        pathRewrite: {
          '^/test': ''
        }
      },
      '/consumption': {
        // target: 'http://localhost:8883/',
        target: 'http://10.126.249.185:11002',
        changeOrigin: true,
        pathRewrite: {
          '^/consumption': ''
        }
      },
      '/portal': {
        target: 'http://123.117.129.158/ipark/portal',
        changeOrigin: true,
        pathRewrite: {
          '^/portal': ''
        }
      },
      // '/api': {
      //   target: 'http://10.126.249.186:7008/',
      //   changeOrigin: true,
      //   pathRewrite: {
      //     '^/api': ''
      //   }
      // },
      '/ipark':{
        target:':http://localhost:8883/',
        // target: baseUrl,
        changeOrigin:true,
        // pathRewrite: {
        //   '^/ipark': ''
        // }
      },
      '/mock/': {
        target: 'http://localhost:9999/',
        changeOrigin: true,
        pathRewrite: {
          '^/mock/': '/'
        }
      }
    },
    // Various Dev Server settings
    host: 'localhost', // can be overwritten by process.env.HOST
    // host: '0.0.0.0', // can be overwritten by process.env.HOST
    port: 8080, // can be overwritten by process.env.PORT, if port is in use, a free one will be determined
    autoOpenBrowser: false,
    errorOverlay: true,
    notifyOnErrors: true,
    poll: false, // https://webpack.js.org/configuration/dev-server/#devserver-watchoptions-

    // Use Eslint Loader?
    // If true, your code will be linted during bundling and
    // linting errors and warnings will be shown in the console.
    useEslint: true,
    // If true, eslint errors and warnings will also be shown in the error overlay
    // in the browser.
    showEslintErrorsInOverlay: false,

    /**
     * Source Maps
     */

    // https://webpack.js.org/configuration/devtool/#development
    devtool: 'cheap-module-eval-source-map',

    // If you have problems debugging vue-files in devtools,
    // set this to false - it *may* help
    // https://vue-loader.vuejs.org/en/options.html#cachebusting
    cacheBusting: true,

    cssSourceMap: true,
    bundleAnalyzerReport: false
  },

  build: {
    baseURL:'',
    // Template for index.html
    index: path.resolve(__dirname, '../dcitsadmin/index.html'),
    httpSetting: {
      timeout: 60000, // 超时时间
      responseType: 'json' // 结果返回类型，默认全部为json，其它类型的单独处理
    },
    // Paths
    assetsRoot: path.resolve(__dirname, '../'),
    assetsSubDirectory: 'dcitsadmin',
    assetsPublicPath: '/front/',
    /**
     * Source Maps
     */

    productionSourceMap: true,
    // https://webpack.js.org/configuration/devtool/#production
    devtool: '#source-map',

    // Gzip off by default as many popular static hosts such as
    // Surge or Netlify already gzip all static assets for you.
    // Before setting to `true`, make sure to:
    // npm install --save-dev compression-webpack-plugin
    productionGzip: false,
    productionGzipExtensions: ['js', 'css'],

    // Run the build command with an extra argument to
    // View the bundle analyzer report after build finishes:
    // `npm run build --report`
    // Set to `true` or `false` to always turn it on or off
    bundleAnalyzerReport: false
  }
}



// WEBPACK FOOTER //
// ./config/index.js